<template>
    <div class="layout">
        <router-view class="router-view" v-slot="{ Component }">
            <transition :name="transitionName">
                <keep-alive>
                    <component :is="Component" v-if="$route.meta.keepAlive" :key="$route.path" />
                </keep-alive>
            </transition>
            <transition :name="transitionName">
                <component :is="Component" v-if="!$route.meta.keepAlive" :key="$route.path" />
            </transition>
        </router-view>
    </div>
</template>

<script lang="ts">
import { useStore } from 'vuex';
import { onBeforeMount, ref } from '@vue/runtime-core';
import { defineComponent } from 'vue';
import { onBeforeRouteUpdate } from 'vue-router';

export default defineComponent({
    components: {},
    setup() {
        // 获取vuex对象
        const store = useStore();
        const transitionName = ref('slide-left');

        onBeforeMount(() => {
            console.log('获取用户信息');
            // 获取用户信息
            store.dispatch('user/USER_INFO');

            // 获取用户设置
            const userGUID = store.state.user.userInfo.UserGUID;
            const paramsUserSettings = {
                userId: userGUID,
            };
            store.dispatch('user/USER_SETTINGS', paramsUserSettings);
        });
        // 页面切换过度
        onBeforeRouteUpdate((to: any, from: any) => {
            if (to.meta.index > from.meta.index) {
                transitionName.value = 'slide-left';
            } else if (to.meta.index < from.meta.index) {
                transitionName.value = 'slide-right';
            } else {
                transitionName.value = '';
            }
        });
        return { transitionName };
    },
});
</script>

<style lang="less">
.layout {
    overflow-x: hidden;
    overflow-y: scroll;
    height: 100%;
    .van-picker__confirm {
        color: #2e87fb !important;
    }
    .title {
        font-size: 16px;
        font-weight: 500;
        color: #333333;
    }
}
.router-view {
    width: 100%;
    height: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: 0 auto;
    -webkit-overflow-scrolling: touch;
}
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
    height: 100%;
    will-change: transform;
    transition: all 500ms cubic-bezier(0.55, 0, 0.1, 1);
    position: absolute;
    backface-visibility: hidden;
}
.slide-right-enter-active {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
}
.slide-right-leave-active {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
}
.slide-left-enter-active {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
}
.slide-left-leave-active {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
}
</style>
